export const fonts = {
    'helvetica' :'Helvetica',
    'arial' : 'Arial',
    'tahoma' : 'Tahoma',
    'treubuchet_ms' : 'Trebuchet MS',
    'times_new_roman' : 'Times New Roman',
    'georgia' : 'Georgia',
    'garamond' : 'Garamond',
    'courier_new' : 'Courier New',
    'brush_script':'"Brush Script MT", cursive',
    'impact':'Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;',
    'segoe_UI':"Segoe UI,Segoe UI Variable Text,-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Arial,sans-serif",
     'roboto' : '"Roboto", sans-serif',
    'roboto_mono' : '"Roboto Mono", monospace',
    'roboto_condensed' : '"Roboto Condensed", sans-serif',
    'montserrat' : '"Montserrat", sans-serif',
    'rubik' : '"Rubik", sans-serif',
    'open_sans' : '"Open Sans", sans-serif',
    'google_sans' : '"Google Sans", sans-serif',
    'lato' : '"Lato", sans-serif',
    'poppins' : '"Poppins", sans-serif',
    'noto_sans' : '"Noto Sans", sans-serif',
    'inter':'"Inter", sans-serif',
    'playfair_display':'"Playfair Display", serif',
    'arimo' : '"Arimo", sans-serif',
    'oswald' : '"Oswald", sans-serif',
    'raleway' : '"Raleway", sans-serif',
    'nunito' : '"Nunito", sans-serif',
    'nunito_sans' : '"Nunito Sans", sans-serif',  
    'crimson_text' : '"Crimson Text", serif',
    'dm_sans' : '"DM Sans", sans-serif',
    'ubuntu' : '"Ubuntu", sans-serif',
    'archivo' : '"Archivo", sans-serif',  
    'lobster' : '"Lobster", sans-serif',   
    'red_hat_display' : '"Red Hat Display", sans-serif',  
    'pacifico' : '"Pacifico", cursive', 
    'oxygen' : '"Oxygen", sans-serif',
    'roboto_slab' : '"Roboto Slab", serif',
    'bricologe_grotesque':'"Bricolage Grotesque", sans-serif',
    'grey_qo': '"Grey Qo", cursive',
    'passions_conflict':'"Passions Conflict", cursive',
    'lovers_quarrel':'"Lovers Quarrel", cursive',
    'engagement':'"Engagement", cursive',
    'work_sans':'"Work Sans", sans-serif',
    'source_sans_3':'Source Sans 3", sans-serif',
    'merriweather':'"Merriweather", serif',
    'bodoni_moda':'"Bodoni Moda", serif',
    'cormorant_SC':'"Cormorant SC", serif',
    'libre_caslon_text':'"Libre Caslon Text", serif',
    'libre_baskerville':'"Libre Baskerville", serif',
    'spectral':'"Spectral", serif',
    'bebas_neue':'"Bebas Neue", sans-serif',
    'anton':'"Anton", sans-serif',
    'abril_fatface':'"Abril Fatface", serif',
    'league_spartan':'"League Spartan", sans-serif',
    'great_vibes':'"Great Vibes", cursive',
    'dancing_script':'"Dancing Script", cursive',
   'allura':'"Allura", cursive',
   'satisfy':'"Satisfy", cursive',
   'sacramento':'"Sacramento", cursive',
   'playball':'"Playball", cursive',
   'amatic_SC':'"Amatic SC", sans-serif'
}


export const isSystemFont = (font)=>{
// System fonts list
  const systemFonts = [
    "helvetica",
    "arial",
    "tahoma",
    "treubuchet_ms",
    "times_new_roman",
    "georgia",
    "garamond",
    "courier_new",
    "brush_script",
    "impact",
    "segoe_UI",
  ];
  return systemFonts.includes(font.toLowerCase());
}


export const addGoogleFontCss = (font) =>{
     const existingLink = document.getElementById(`dynamic-font`);
          if (existingLink) existingLink.remove();
    
          let fontForLink = font.trim();
    
          // 2. Capitalize each word
          fontForLink = fontForLink
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join("+");
    
          // Create new link element
          const link = document.createElement("link");
          link.id = `dynamic-font`;
          link.rel = "stylesheet";
          link.href = `https://fonts.googleapis.com/css?family=${fontForLink}&display=swap`;
          link.media = "all";
    
          document.head.appendChild(link);
}